import React from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/styles/index.css';
import App from 'App';
import { analyticsService } from 'services/analyticsService';

// Fix Descope SDK bug: when third-party cookies are blocked, the SDK builds
// the Authorization header as "Bearer {projectId} :{jwt}" (space before colon)
// instead of "Bearer {projectId}:{jwt}", causing E011008. Intercept and fix.
const _originalFetch = window.fetch.bind(window);
window.fetch = async function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (init?.headers) {
    const headers = new Headers(init.headers as HeadersInit);
    const auth = headers.get('Authorization');
    if (auth && / :eyJ/.test(auth)) {
      headers.set('Authorization', auth.replace(/ :eyJ/, ':eyJ'));
      init = { ...init, headers };
    }
  }
  return _originalFetch(input, init);
};

// Initialize Mixpanel
analyticsService.init();

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element. Make sure there is a <div id="root"></div> in your HTML.');
}

// Create root and render the app
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// import reportWebVitals from './reportWebVitals';
// reportWebVitals();
